import { css } from "@emotion/react";

import { UnlockGateResult } from "apollo/graphql.generated";
import { LockedPage } from "~/features/pages/LockedPage";

import PreviewContentFooter from "./PreviewContentFooter";
import { Page } from "./state";

interface PreviewLockedProps {
  page: Page;
  unlockGateResult?: UnlockGateResult;
}

const containerStyles = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
`;

export const PreviewLocked = ({
  page,
  unlockGateResult,
}: PreviewLockedProps) => {
  return (
    <div css={containerStyles}>
      <LockedPage
        lockedMessage={page.gate?.lockedMessage || ""}
        unlockGateResult={unlockGateResult}
        isPreview
      />
      <PreviewContentFooter />
    </div>
  );
};
